<template>
  <v-container class="ma-0 pa-3 transparent subtitle-1" style="padding: 10px; max-width: 100%">
    <v-row no-glutters>
      <v-col cols="12" class="max-auto text-center">
        <span>Powered by <a href="https://www.vbote.com/" target="_blank">VBOTE</a></span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'PageFooter',
  data () {
    return {
    }
  }
}
</script>

<style scoped>
a {
  color: #000000 !important;
}
span {
  font-family: 'Poppins', sans-serif !important;
}
</style>